import { AnimatePresence } from "motion/react";
import { FC, useEffect, useState } from "react";

import { RouteScheduleItemDisplay } from "./route-schedule-item.display";
import { RouteScheduleItemEdit } from "./route-schedule-item.edit";
import { IRouteScheduleForm } from "./table-route-schedule.models";

export const RouteScheduleItem: FC<IRouteScheduleForm> = ({
  fieldName,
  index,
  value,
  control,
  setValue,
  removeHandler,
  disabledEdit,
  disabledRemove,
  onEditStart,
  onEditEnd,
}) => {
  const [inEdit, setInEdit] = useState(false);

  useEffect(() => {
    if (inEdit) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [inEdit, onEditStart, onEditEnd]);

  return (
    <AnimatePresence mode="wait">
      {!inEdit && (
        <RouteScheduleItemDisplay
          key="display"
          disabledEdit={disabledEdit}
          disabledRemove={disabledRemove}
          fieldName={fieldName}
          setValue={setValue}
          control={control}
          removeHandler={removeHandler}
          index={index}
          value={value}
          onEdit={() => {
            setInEdit(true);
          }}
        />
      )}

      {inEdit && (
        <RouteScheduleItemEdit
          key="edit"
          fieldName={fieldName}
          setValue={setValue}
          index={index}
          value={value}
          onCancel={() => {
            setInEdit(false);
          }}
        />
      )}
    </AnimatePresence>
  );
};
